var XMLSelect = (function($) {

    function load(opts) {
        opts = _.extend({}, {dataType: 'xml'}, opts);

        var xhr = $.ajax(opts), $el = this;
        $el.empty();

        return xhr.then(function(xml) {
            var ixsel = 0;
            $(xml).find('option').each(function(ix, node) {
                var data={}, $option = $('<option />');

                $(node).children().each(function() {
                    var tag = this.tagName, text = $(this).text();

                    switch (tag) {
                        case 'value':
                                $option.attr('value', text);
                            break;
                        case 'text':
                                $option.text(text);
                            break;
                        case 'class':
                                $option.addClass(text);
                            break;
                        case 'selected':
                                if (text.toLowerCase()==='true')
                                    ixsel = ix;
                            break;
                        default:
                            data[tag] = text;
                            break;
                    }

                });

                $option.data('info', data);
                $el.append($option);
            });
            $el.get(0).selectedIndex = ixsel;

            return $el;
        })
    }


    function wrap(el, action) {
        var $el = $(el);

        switch (action) {
            case 'load' : return load.apply($el, _.rest(arguments, 2));
        }

        return null;
    }


    return wrap;
})(jQuery);